import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../components/Breadcrumb';

const Sitemap = () => {
  const pages = [
    { title: 'Startseite', path: '/' },
    { title: 'Leistungen (Übersicht)', path: '/leistungen' },
    { title: 'Haushaltsauflösung Dortmund', path: '/haushaltsaufloesung-dortmund' },
    { title: 'Wohnungsauflösung Dortmund', path: '/wohnungsaufloesung-dortmund' },
    { title: 'Messi-Wohnung Dortmund', path: '/messie-wohnung-dortmund' },
    { title: 'Keller & Dachboden Entrümpelung Dortmund', path: '/keller-dachboden-entruempelung-dortmund' },
    { title: 'Sperrmüll-Abtransport Dortmund', path: '/sperrmuell-abtransport-dortmund' },
    { title: 'Nachlassauflösung Dortmund', path: '/nachlassaufloesung-dortmund' },
    { title: 'Preise & Ablauf', path: '/preise' },
    { title: 'Einsatzgebiet Dortmund', path: '/einsatzgebiet-dortmund' },
    { title: 'Über uns', path: '/ueber-uns' },
    { title: 'Kontakt', path: '/kontakt' },
    { title: 'FAQ', path: '/faq' },
    { title: 'Ratgeber (Blog)', path: '/blog' },
    { title: 'Impressum', path: '/impressum' },
    { title: 'Datenschutz', path: '/datenschutz' }
  ];

  return (
    <div className="bg-white py-12">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <Breadcrumb items={[{ label: 'Sitemap' }]} />
        
        <h1 className="text-4xl font-bold text-[#0F172A] mb-6">Sitemap</h1>
        <p className="text-lg text-gray-700 mb-12">
          Überblick über alle Seiten von haushaltsaufloesung.services
        </p>

        <div className="bg-gray-50 rounded-lg p-8">
          <ul className="space-y-3">
            {pages.map((page, index) => (
              <li key={index} className="flex items-start gap-3">
                <span className="text-[#16A34A] font-bold mt-1">•</span>
                <Link to={page.path} className="text-[#16A34A] hover:underline text-lg">
                  {page.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-12 bg-[#0F172A] text-white rounded-lg p-8 text-center">
          <h2 className="text-2xl font-bold mb-4">Fragen? Wir helfen gerne!</h2>
          <p className="mb-6">Kontaktieren Sie uns für Ihr Festpreis-Angebot.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/kontakt" className="px-6 py-3 bg-[#16A34A] hover:bg-[#16A34A]/90 text-white rounded-md font-medium transition-colors">
              Zum Kontaktformular
            </Link>
            <a href="tel:+4923139085116" className="px-6 py-3 bg-white text-[#0F172A] hover:bg-gray-100 rounded-md font-medium transition-colors">
              0231 39085116
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sitemap;